"use client";

import { Button, ButtonProps } from "./ui/button";
import { useRouter } from "next/navigation";

export function BackButton(props: ButtonProps) {
  const router = useRouter();

  return <Button {...props} onClick={() => router.back()} />;
}
